import api from './api';

export async function getLevels() {
  return api.get(`/levels`);
}

export async function getLevelById(id) {
  return api.get(`/levels/${id}`);
}
